import dynamic from 'next/dynamic';

import { breakUpLongTask } from '@/utils/breakUpLongTasks/breakUpLongTasks';
export default dynamic(breakUpLongTask(() => import(/* webpackChunkName:"Chatbot" */ './Chatbot')));
